// Extend curve with extra points
export function FillInGaps(data) {
	let result = [];
	if (data?.length) {
		// Calculate middle distance of points.
		let distance = 0;
		let last_x, last_y;
		let last_end = true;

		data.forEach((pos) => {
			if (!last_end) {
				distance += Math.sqrt((pos[0] - last_x) ** 2 + (pos[1] - last_y) ** 2);
			}
			last_x = pos[0];
			last_y = pos[1];
			last_end = pos[2];
		});
		let middle_distance = distance / data.length;

		// Add empty points to fill out path
		last_x = undefined;
		last_end = false;
		data.push(data[0]); // Add first object last (remove it later)
		data.forEach((pos) => {
			if (last_end === true && !pos[2]) {
				let distance = Math.sqrt((pos[0] - last_x) ** 2 + (pos[1] - last_y) ** 2);
				let fillin = Math.floor(distance / middle_distance);
				for (let i = 0; i < fillin; i++) {
					result.push(
						[
							(last_x + (pos[0] - last_x) * (i / fillin)),
							(last_y + (pos[1] - last_y) * (i / fillin)),
							true
						]
					);
				}
			}
			last_x = pos[0];
			last_y = pos[1];
			last_end = pos[2];
			result.push(pos);
		});

		result.pop(); // Return last object that we added before.
		data.pop();
	}
	return result;
}

export function Normalize(data, margin = 1) {
	let result = [];
	let xvalues = [];
	let yvalues = [];
	if (data.length) {
		data.forEach((pos) => {
			xvalues.push(pos[0]);
			yvalues.push(pos[1]);
		});
		let xmin = Math.min(...xvalues);
		let xmax = Math.max(...xvalues);
		let ymin = Math.min(...yvalues);
		let ymax = Math.max(...yvalues);
		let maxdiff = Math.max(xmax - xmin, ymax - ymin);
		data.forEach((pos) => {
			result.push([
				((pos[0] - xmin - (xmax - xmin) / 2) / (maxdiff / 2)) * margin,
				((pos[1] - ymin - (ymax - ymin) / 2) / (maxdiff / 2)) * margin,
				pos[2]
			])
		});
	}
	return result;
}


export function SvgGetPoints(paths, xoffset = 0, yoffset = 0) {
	let result = [];
	for (let i = 0; i < paths.length; i++) {
		let path = paths[i];
		let length = path.getTotalLength();
		let step = 0;
		while (step < length) {
			var pos = path.getPointAtLength(step);
			result.push([
				pos.x + xoffset,
				pos.y + yoffset]);
			step += length / 1000;
		}
	}
	result[result.length -1][2] = true; // Mark last point as end
	// console.log("svg result", result);
	return result;
}

